var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"swiper"},[_c('div',{staticClass:"toptexts"},[_c('div',{staticClass:"imgtitle"},[_vm._v(_vm._s(_vm.detail.Name))]),_c('div',{staticClass:"texts"},[_vm._v(_vm._s(_vm.detail.Summary))])])]),_c('div',{staticClass:"width1200",domProps:{"innerHTML":_vm._s(_vm.detail.Content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }